<template>
    <div class="PatchSearch">
        <Form ref="patchForm" :model="patchForm" :rules="ruleValidate">
            <Row :gutter="4">
                <Col span="5">
                    <FormItem prop="accountIdSearchKey">
                        <Select v-model="patchForm.accountIdSearchKey" filterable :placeholder="$t('patch_management.patch_policy.queryByAccount')"  @on-change="changeAccountId(patchForm.accountIdSearchKey)" :transfer="true">
                            <Option :value="item.id" v-for="item in accountIdList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="5">
                    <FormItem prop="regionSearchKey">
                        <Select v-model="patchForm.regionSearchKey" filterable :placeholder="$t('patch_management.patch_policy.queryByRegion')" :transfer="true">
                            <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="5">
                    <Input search v-model="severitySearchKey" :placeholder="$t('patch_management.patch_policy.queryBySeverity')"/>
                </Col>
                <Col span="5">
                    <Button type="primary" :loading="modal_loading" @click="search('patchForm')" v-hasPermission="['patchManagement:patchBaselineConfiguration:search_patch']">{{$t('patch_management.patch_policy.search')}}</Button>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
    import TablePatch from '../patch_baseline_configuration/TablePatch'
    var tablePatch = TablePatch;
    export default {
        name: 'PatchSearch',
        data () {
            return {
                patchForm: {
                    accountIdSearchKey:'',
                    regionSearchKey:''
                },
                modal_loading:false,
                severitySearchKey:'',
                accountIdList:[], //账号
                regionList:[], //区域
                ruleValidate: {
                    accountIdSearchKey: [
                        { required: true, message: this.$t("patch_management.patch_policy.inputValidation.requiredAccount"), trigger: 'change',type:'number' }
                    ],
                    regionSearchKey: [
                        { required: true, message: this.$t("patch_management.patch_policy.inputValidation.requiredRegion"), trigger: 'change' }
                    ]
                }
            }
        },
        mounted: function(){
            this.selectAccountByCloudPlatform();
        },
        methods: {
            /**********************账号********************************/
            //查询账号
            selectAccountByCloudPlatform: function(){
                this.$api.account.selectAccountByCloudPlatform("type",0)
                .then(res => {
                    this.accountIdList = res.data;
                })
            },
            // 按账号筛选
            changeAccountId: function(){
                this.patchForm.regionSearchKey='';
                this.queryAccountRegions();
            },
            /**********************区域********************************/
            //查询地区
            queryAccountRegions: function(){
                this.$api.account.queryAccountRegions("accountId",this.patchForm.accountIdSearchKey)
                .then(res => {
                    this.regionList = res.data;
                })
            },
            /**********************搜索********************************/
            search: function (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        tablePatch.methods.showAll(this.patchForm.accountIdSearchKey,this.patchForm.regionSearchKey,this.severitySearchKey);
                    }
                })
            }
        }
    }
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/patch_management/policy/patch_baseline_configuration/PatchSearch.vue